import React, { useState, useEffect, useReducer, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCurrencySettingsAction } from "../actions";
import { getLoading, getData } from "../selectors";
import { getAppColor } from "@icarius-app/selectors";
import { Grid } from "@material-ui/core";
import DataItem from "./data/dataItem";
import { RESET_STATE } from "../actionTypes";
import paths from "@icarius-router/paths";
import ABMLayout from "@icarius-common/abmComponents/abmLayout";
import { reducer, initialState } from "../reducer";
import MembersDialog from "./collaboratorsDialog";
import { getLocalizedString } from "@icarius-localization/strings";

const CurrencySettings = ({ history }) => {
    const [createIsOpen, setCreateIsOpen] = useState(false);
    const [state, dispatchLocalReducer] = useReducer(reducer, initialState);

    const dispatch = useDispatch();

    const color = useSelector(getAppColor);
    const data = useSelector(getData);
    const isLoading = useSelector(getLoading);

    useEffect(() => {
        dispatch(getCurrencySettingsAction());
        return () => {
            dispatch({ type: RESET_STATE });
        };
    }, [dispatch]);

    const getDataIsEmpty = () => {
        return !data || data.length === 0;
    };

    const handleGoBack = () => {
        history.push(paths.organizationalDefinitions);
    };

    const handleOpenMembersDialog = useCallback(
        (group) => dispatchLocalReducer({ type: "OPEN_MEMBERS_DIALOG", payload: group }),
        []
    );
    const handleCloseMembersDialog = () => dispatchLocalReducer({ type: "CLOSE_MEMBERS_DIALOG" });

    return (
        <ABMLayout
            title={getLocalizedString("currencySettings")}
            isLoading={isLoading}
            showCreateButton={!createIsOpen}
            createButtonTitle={getLocalizedString("currencySettingsNew")}
            createButtonOnClick={() => setCreateIsOpen(true)}
            showGoBack
            handleGoBack={handleGoBack}
            showNoData={getDataIsEmpty()}
            noDataTitle={getLocalizedString("currencySettingsNoCurrenciesFound")}
            noDataCreateTitle={getLocalizedString("currencySettingsNew")}
            noDataOnClick={() => setCreateIsOpen(true)}
        >
            {state.membersDialogIsOpen && (
                <MembersDialog
                    open={state.membersDialogIsOpen}
                    collaborators={state.selectedCurrency?.assigned || []}
                    handleClose={handleCloseMembersDialog}
                />
            )}
            {createIsOpen && (
                <Grid container item xs={12} style={{ margin: "10px 0px" }}>
                    <DataItem color={color} data={null} closeNew={() => setCreateIsOpen(false)} />
                </Grid>
            )}
            {data &&
                data.map((item) => {
                    return (
                        <Grid container item xs={12} style={{ margin: "10px 0px" }} key={item.code}>
                            <DataItem data={item} color={color} handleOpenMembersDialog={handleOpenMembersDialog} />
                        </Grid>
                    );
                })}
        </ABMLayout>
    );
};

export default CurrencySettings;
